import { gql } from '@apollo/client'
import subgraph from '~/modules/Vault/Infrastructure/subgraph'

export interface Vault {
  vaultAddress: string
}

export const findVault = async (nftAddress: string | undefined, nftId: string | null): Promise<Vault | undefined> => {
  if (!nftAddress || !nftId) return undefined

  const query = gql`
    query GetVault($nftAddress: String!, $nftId: String!) {
      fragmentsVaultCreateds (where: { nftAddress: $nftAddress, nftId: $nftId }) {
        vaultAddress
      }
    }
  `

  const { data } = await subgraph.query({
    query,
    variables: { nftAddress: nftAddress.toLowerCase(), nftId },
  })

  return data.fragmentsVaultCreateds.length > 0
    ? data.fragmentsVaultCreateds[0]
    : undefined
}
